import { paths } from '@AppRoutes/constants.js';

const historyAndAlertsForTabViewClass = 'u-els-display-none u-els-display-inline@tablet';

export default {
  quickSearch: {
    id: 'general-menu-quick-search',
    label: 'Quick search',
    path: paths.SEARCH,
    trackingName: 'header:navigation:quick-search',
  },
  queryBuilder: {
    id: 'general-menu-query-builder',
    label: 'Query builder',
    path: paths.ADVANCED,
    trackingName: 'header:navigation:query-builder',
  },
  results: {
    id: 'general-menu-results',
    label: 'Results',
    path: '#',
    trackingName: 'header:navigation:results',
  },
  alerts: {
    id: 'general-menu-alerts',
    label: 'Alerts',
    path: paths.ALERTS,
    className: historyAndAlertsForTabViewClass,
    trackingName: 'header:navigation:alerts',
  },
  conditions: {
    id: 'general-menu-conditions',
    label: 'Conditions navigator',
    isNew: true,
    path: paths.CONDITIONS,
    trackingName: 'header:navigation:conditions-navigator',
  },
  retrosynthesis: {
    id: 'general-menu-retrosynthesis',
    label: 'Retrosynthesis',
    path: paths.RS,
    trackingName: 'header:navigation:retrosynthesis',
  },
  history: {
    id: 'general-menu-historyNav',
    label: 'History',
    path: paths.HISTORY_RECENT,
    className: historyAndAlertsForTabViewClass,
    trackingName: 'header:navigation:history',
  },
  historySaved: {
    id: 'general-menu-historyNav',
    label: 'History',
    path: paths.HISTORY_SAVED,
    className: historyAndAlertsForTabViewClass,
    trackingName: 'header:navigation:history-saved',
  },
};
